export const MIN_DISPLAY_COUNT = 2;
